"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LayersOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var LayersOutlineSVG = function LayersOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29 13.91l-1.81-1 1.9-1.18a2 2 0 00-.09-3.4L17 1.76a2.13 2.13 0 00-2 0L3 8.33a2 2 0 000 3.4l1.9 1.18-1.9 1a2 2 0 000 3.4l1.82 1.13-1.82.95a2 2 0 000 3.4l11.94 7.39a2.09 2.09 0 002.22 0l11.94-7.39a2 2 0 00-.09-3.4l-1.73-.95 1.82-1.13a2 2 0 00-.1-3.4zM4.06 10.06L16 3.49l11.94 6.57-2.81 1.74-2 1.21L16 17.45 8.83 13l-2-1.21zm23.88 11.06L16 28.51 4.06 21.12l2.67-1.47 8.16 5.05a2.09 2.09 0 002.22 0l8.16-5.05zM16 23L4.06 15.64l2.75-1.52 8.08 5a2.09 2.09 0 002.22 0l8.08-5 2.75 1.52z"
  }));
};
exports.LayersOutlineSVG = LayersOutlineSVG;
LayersOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LayersOutlineSVG);
exports.default = _default;